// extracted by mini-css-extract-plugin
export default {"loader":"KDOTB","spinAround":"Gokqo"};